/** The dashboard's setup wizard steps, by number: three since Oct 29. */
export const SETUP_WIZARD_STEP_NAMES: Record<number, string> = {
  1: 'Leads',
  2: 'Your form',
  3: 'Go live',
};

/** Step 3's "Where will people find it?", kept on setup_wizard_published as metadata.shareChoice. */
export const SETUP_WIZARD_SHARE_LABELS: Record<string, string> = {
  link: 'A link',
  funnel: 'GoHighLevel funnel',
  site: 'Website',
};

/** "2. Your form". */
export const setupWizardStepLabel = (step: number) => `${step}. ${SETUP_WIZARD_STEP_NAMES[step] ?? 'Unknown'}`;
